import SetupRmStifSmsModal from './setup-rm-stif-sms-modal.vue'
export default SetupRmStifSmsModal
